<template>
  <mts-dialog v-model="syncShowModal" width="800">
    <div class="terms-of-use-modal">
      <div class="terms-of-use-modal__title">
        <p class="terms-of-use-modal__title-text">Условия проведения торгов</p>
      </div>

      <div class="terms-of-use-modal__content">
        <div class="terms-of-use-modal-wrapper">
          <terms-of-use-content />
        </div>
      </div>
    </div>

    <template v-slot:footer>
      <div class="terms-of-use-modal__actions">
        <mts-button type="outline" theme="dark" v-on:click="close">Закрыть</mts-button>
      </div>
    </template>
  </mts-dialog>
</template>

<script>
  import TermsOfUseContent from './TermsOfUseContent';

  export default {
    name: 'TermsOfUseModal',
    components: {
      TermsOfUseContent
    },
    props: {
      showModal: { type: Boolean, default: false }
    },
    computed: {
      syncShowModal: {
        get() {
          return this.showModal;
        },
        set(value) {
          this.$emit('update:show-modal', value);
        }
      }
    },
    methods: {

      close() {
        this.syncShowModal = false;
      }
    }
  };
</script>

<style>
  .terms-of-use-modal__title {}
  .terms-of-use-modal__title-text {
    font-family: 'MTSSansWebRegular';
    font-size: 16px;
    line-height: 20px;
  }

  .terms-of-use-modal-wrapper {
    margin: 14px 12px;
  }

  .terms-of-use-modal__content {
    margin-top: 20px;
    border-radius: var(--base-radius);
    border: 2px solid var(--color-link-water);
    height: 430px;
    overflow-y: scroll;
  }

  .terms-of-use-modal__actions {
    display: flex;
    justify-content: flex-end;
  }
</style>
